import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

/**
 * Animated hamburger icon button that transitions to an "X".
 * Meant to be used as a trigger for mobile navigation / drawers.
 */
export function HamburgerButton({
	open = false,
	className,
	...props
}: React.ComponentProps<'button'> & { open?: boolean }) {
	return (
		<button
			type="button"
			aria-label={open ? 'Close menu' : 'Open menu'}
			aria-expanded={open}
			data-slot="hamburger-button"
			className={cn(
				'relative inline-flex size-10 items-center justify-center p-2',
				className,
			)}
			{...props}
		>
			{/* Top bar */}
			<span
				className={cn(
					'absolute h-0.5 bg-current transition-all duration-300',
					open ? 'w-[17px] translate-y-0 rotate-45' : 'w-6 -translate-y-2',
				)}
			/>
			{/* Middle bar */}
			<span
				className={cn(
					'absolute h-0.5 w-6 bg-current transition-opacity duration-300',
					open ? 'opacity-0' : 'opacity-100',
				)}
			/>
			{/* Bottom bar */}
			<span
				className={cn(
					'absolute h-0.5 bg-current transition-all duration-300',
					open ? 'w-[17px] translate-y-0 -rotate-45' : 'w-6 translate-y-2',
				)}
			/>
		</button>
	)
}
